import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button, Form } from 'semantic-ui-react';
export const StyledForm = styled(Form) `
  border: 0;
`;
export const StyledButton = styled(Button) `
  border-radius: 30px !important;
  background-color: #00d2ff !important;
  color: #01294e !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  line-height: 23px !important;
  padding: 13px 30px !important;

  &:disabled {
    background-color: #f4f5f7 !important;
    color: #cccccc !important;
  }
`;
export const ButtonWrapper = styled.div `
  display: flex;
  width: 100%;
  justify-content: start;
  padding: 20px 0;
`;
export const FormTitle = styled.h2 `
  font-size: 21px;
  color: #01294e;
  margin-bottom: 25px;
  font-weight: 600;
`;
export const FormDescription = styled.p `
  font-size: 14px;
  color: #01294E;
  margin-bottom: 20px;
`;
export const AccountLinkText = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  line-height: 17px;
  font-weight: 600;
  color: #01294e;
  background-color: #e9ecf0;
  padding: 20px;
  border-radius: inherit;
  white-space: pre;
`;
export const StyledLink = styled(Link) `
  text-decoration: underline;
  color: #01294e;
`;
export const StyledExternalLink = styled.a `
  text-decoration: underline;
  color: #01294e;
  cursor: pointer;
`;
export const BackButton = styled.button `
  background: none;
  border: none;
  color: #01294e;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  
  &:hover {
    opacity: 0.8;
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;
export const ErrorMessage = styled.div `
  color: #db2828;
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
`;
export const CheckboxContainer = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;
export const CheckboxLabel = styled.label `
  margin: 0 0 0 10px;
  font-size: 0.95rem;
`;
